import { Action, initialState, State } from 'store/store';
import {
  getAllTopicsOrdered,
  getInteractionsFromTopicAndState,
} from 'selectors/block';
import { Block } from '@chameleoncreator/creator-app';

import isAndroidSamsung from 'services/isAndroidSamsung';
import isAppleComputerInc from 'services/isAppleComputerInc';

const isDevice = isAppleComputerInc() || isAndroidSamsung();

export const preprocessModule = (
  state: State = initialState,
  { data }: Action
): State => {
  const topics = getAllTopicsOrdered(state.blocks);
  const nextInteractionMap = {};
  const idToSIdMap = {};
  const sIdToIdMap = {};

  let interactionsOpen: string[] = [];
  let interactionsLocked: string[] = [];
  // *
  // when we're wanting to test this locally we need to include this line
  // since there's different timings to when savedState loads from scorm/localStorage
  // state.interactionsLocked || [];

  // it's likely ( for sure ) that moduleIsFreeScrolling will not exist on existing modules
  // that already have their state defined on the server
  const moduleIsFreeScrolling = state.theme.moduleIsFreeScrolling || {
    desktop: false,
    device: false,
  };

  const {
    desktop: moduleIsFreeScrollingDesktop,
    device: moduleIsFreeScrollingDevice,
  } = moduleIsFreeScrolling;

  topics.forEach(topic => {
    const interactions = getInteractionsFromTopicAndState(
      state as any,
      (Object.values(state.blocks) as any).find(($: any) => $.id === topic.id)
    );

    interactions.forEach((interaction, index) => {
      const { id } = interaction;
      const { sId, lockDown } = (interaction as any)?.props;

      if (!isDevice) {
        moduleIsFreeScrollingDesktop && interactionsOpen.push(id);
        !moduleIsFreeScrollingDesktop &&
          lockDown &&
          interactionsLocked.push(id);
      }

      if (isDevice) {
        moduleIsFreeScrollingDevice && interactionsOpen.push(id);
        !moduleIsFreeScrollingDevice && lockDown && interactionsLocked.push(id);
      }

      // if (lockDown) {
      //   interactionsLocked.push(id);
      // }

      idToSIdMap[id] = sId;
      sIdToIdMap[sId] = id;

      if (index != interactions.length - 1) {
        nextInteractionMap[id] = interactions[index + 1].id;
      }
    });
  });

  return {
    ...state,
    ...data,
    interactionsOpen,
    interactionsLocked,
    ...{ nextInteractionMap },
    ...{ idToSIdMap },
    ...{ sIdToIdMap },
  };
};
